/**
 * Handler that always returns `true`.
 */
export const PRIZM_ALWAYS_TRUE_HANDLER = (): true => true;
